module.exports = __webpack_public_path__ + "img/DE00453.4725bca3.png";